import {React,IndexRoute} from 'react'
import Main from './pages/main'
import Stack from './pages/stack'
import {BrowserRouter, Switch, Route} from 'react-router-dom'
import Contatos from './pages/contatos'

const Routes = () => (
    <BrowserRouter>
        <Switch>
        <Route exact path ='/' component = {Main}/>
        <Route exact path ='/home' component = {Main}/>
        <Route exact path ='/stack' component = {Stack}/>
        <Route exact path ='/contato' component = {Contatos}/>
        </Switch>
    
    </BrowserRouter>
)

export default Routes